import * as yup from 'yup'
import { CommodityFormProfile } from './commodity-form.profile'

export const schema = (): yup.ObjectSchema<CommodityFormProfile> =>
  yup.object({
    id: yup.number().optional(),
    code: yup.string().label('Code').emptyAsUndefined().required(),
    name: yup.string().label('Name').emptyAsUndefined().required(),
    catalogueId: yup.number().label('Catalogue ID').emptyAsUndefined().required(),
    isActive: yup.boolean().label('Is Active').required(),
    isSelectable: yup.boolean().label('Is Selectable').required(),
    description: yup.string().label('Description').emptyAsUndefined().optional(),
    parentCommodityId: yup.number().label('Parent Commodity ID').emptyAsUndefined().optional(),
    height: yup.number().label('Height').emptyAsUndefined(),
    length: yup.number().label('Length').emptyAsUndefined(),
    width: yup.number().label('Width').emptyAsUndefined(),
    weight: yup.number().label('Weight').emptyAsUndefined(),
    classDefinition: yup.string().label('Class').emptyAsUndefined(),
    instructions: yup.string().label('Instructions').emptyAsUndefined(),
    packages: yup.array().optional(),
    packageIds: yup.array(),
    attributes: yup
      .array()
      .required()
      .of(
        yup.object({
          name: yup.string().label('Name').required(),
          value: yup.string().label('Value').required(),
        }),
      ),
  })
